import { BCTransplantLink } from '~/components/BCTransplantLink'
import { RegistrationForm } from '~/components/RegistrationForm'
import { Failure } from '~/components/dialogs/register/Failure'
import { Success } from '~/components/dialogs/register/Success'
import { useActionData, useLoaderData, useLocation, useNavigation } from 'react-router'

export { action, loader } from './index.server'

type LoaderData = {
  appVersion: string | undefined
}

export default function Index() {
  const actionData = useActionData() // undefined before form is submitted
  const { appVersion } = useLoaderData<LoaderData>()
  const location = useLocation()

  const getRegistrationSource = (location) => {
    const queryString = location.search
    const queryParams = new URLSearchParams(queryString)
    const result = queryParams.get('location') || 'DS'
    return result
  }
  const registrationSource = getRegistrationSource(location)

  const navigation = useNavigation()
  const isSubmitting = navigation.state === 'submitting'
  return (
    <>
      {!isSubmitting && (
        <>
          {actionData?.success === false && <Failure />}
          {actionData?.success === true && <Success />}
        </>
      )}
      <div className="container mx-auto px-5 pt-2  md:px-20 lg:mb-4 lg:px-52 lg:pb-0">
        <BCTransplantLink />
        <h3 className="pb-3 text-[44px] font-semibold text-primary-green">
          Register your Decision
        </h3>
        <div className="mb-2 text-2xl font-semibold text-[#666666] print:hidden">
          Register your decision with the British Columbia Organ Donor Registry.
        </div>
      </div>
      <div className="h-2 bg-[#6bb244] print:hidden"></div>
      <div className="bg-[url('/images/branded-bg.png')] bg-repeat-round pt-4 print:hidden">
        <div>
          <div className="rounded-t-lg bg-[#fafafa] px-4 py-4 md:px-20 lg:mx-52 lg:mt-12 lg:px-8">
            <p>
              Since 1997, BC's Organ Donor Registry is the official registry of your decision on organ donation.
              Your organ donation decision is not tied to your driver's licence.
            </p>
            <p className="pt-2">
              You only need to register one time, unless you would like to update your decision.
              You do not need to update the form if you have moved or wish to update next-of-kin information (which was included on older forms), as long as your Personal Health Number is the same.
            </p>
            <p className="pt-2">
              If you registered before and complete this form again, the new form will override your previous decision and it will show as a new registration.
            </p>
            <p className="text-md pt-4 text-justify font-semibold text-primary-green md:text-2xl">
              To register, you need:
            </p>
            <ul className="list-inside list-disc">
              <li>your BC Personal Health Number.</li>
              <li>your name, birth date and address in British Columbia.</li>
            </ul>
            <p className="pt-6">You can register your decision at any age, though anyone under the age of 19 who registers in the Organ Donor Registry is recording their expressed wish on organ donation.</p>
            <p className="pt-2">
              People who were registered as minors must register again when they reach the age of 19 to ensure the organ donation decision is their decision.
            </p>
            <p className="pt-2">
              If you are a member of the military and you do not have a BC PHN, please complete{' '}
              <a href="http://www.transplant.bc.ca/Documents/ODR-Paper-Registration-Form-web.pdf">
                this paper form
              </a>{' '}
              and mail it to BC Transplant.
            </p>
          </div>
        </div>
      </div>
      <div className="h-2 bg-[#6bb244]"></div>
      <div className="container mx-auto bg-[url('/images/branded-bg.png')] bg-contain bg-bottom bg-no-repeat p-5  md:px-10  lg:mb-10 lg:p-10 lg:pt-5 2xl:px-52">
        <RegistrationForm errors={actionData?.fieldErrors} registrationSource={registrationSource} />
        <div className="float-right text-slate-200">App version: {appVersion} </div>
      </div>
    </>
  )
}
